exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".folders {\r\n    font-size: 1.4rem;\r\n}\r\n.folders__item {\r\n    margin-bottom: 10px;\r\n\r\n    border-radius: 3px;\r\n}\r\n.folders__item.active,\r\n.folders__item:hover {\r\n    border-right: 3px solid #FCE07C;\r\n\r\n    background-color: #FEF9E8;\r\n}\r\n.folders__link {\r\n    display: block;\r\n    padding: 7px 5px;\r\n\r\n    color: inherit;\r\n    text-decoration: none;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/folders/folders.component.css
// module id = 594
// module chunks = 1